// extracted by mini-css-extract-plugin
module.exports = {"container":"_Dlx5G0-m","layout":"_oegNqzWm","text":"_gqBClM_j","title":"_y0k9mT9v"};